export default __webpack_public_path__ + "static/media/MaduroChurchilClosed.a2261068.jpg";